import { render } from "./AddVbot.vue?vue&type=template&id=d7ada3de"
import script from "./AddVbot.vue?vue&type=script&lang=js"
export * from "./AddVbot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__